import { render, staticRenderFns } from "./editConfigDialog.vue?vue&type=template&id=5fade903&scoped=true"
import script from "./editConfigDialog.vue?vue&type=script&lang=js"
export * from "./editConfigDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fade903",
  null
  
)

export default component.exports